define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/Ref",
	"csi/xml",
	"csi/xml/Query",
	"csi/xml/QueryFilterBuilder"
], function(declare,lang,csi,Action,ViewRef,Ref,xml,Query,QueryFilterBuilder) {

	return declare(Ref, {
		reserveContext: function(/*Context*/ctx, /*Heading*/h) {
			// summary: if rendering from BOM, then allow editing; don't worry about reversing context
			// since there was already a new context applied for the path
			var	node = ctx.getNodeContext();
			if (node && (node.$Type == "ApparelBOMRevision")) {
				ctx.setReadOnly(false);
			}
		},

		_getStoreAction: function(/*Context*/ctx, /*Heading*/h, /*Boolean*/bAll) {
			// summary: add filters from ProductStructure's first placement
			var psHolder = ctx.getNode();
			var urlPS = psHolder.ProductStructure || psHolder.ShapeProductStructure;
			var psp = ctx.cache.addNode(xml.getUrlPath(urlPS, "Child:Placements/Index:0"));
			if (!psp) return null;

			var q = new Query();
			q.Attr("Usable", xml.OP_EQUALS, true);
			q.RefAttr("ProductType", xml.OP_EQUALS, psp.MaterialType);

			// add query filters from placement
			QueryFilterBuilder.create(q,psp.QueryFilter,psHolder.__Parent__,ctx.cache);

			return lang.mixin(new Action(), {
				m_fixedQuery: q,
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "SelectTool",
					m_url: "centric://APPAREL/Views"
				})
			});
		}
	});
});